


























































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { PageItem, FieldItem, SheetField, SheetFieldMark, Pos } from "../../modules/teacher/ScorePositionEdit"
// @ts-ignore
import VueDragResize from "vue-drag-resize";

const DirectionEnum = Object.freeze({Horizontal: 1, Vertical: 2});
const ModeEnum = Object.freeze({Waku: 1, Delete: 2, Assign: 3, Mark: 4});
const FieldTypeEnum = Object.freeze({Field: 1, Mark: 2});

export interface Data {
  tabNo: number
  currentPage: number
  sheet_group_key: string
  sheet: any
  sheetFields: SheetField[]
  pageItems: PageItem[]
  scale: number
  isMouseDown: boolean
  beginPos: Pos
  baseFieldItem: FieldItem
  currentFieldItem: FieldItem | null
  currentSheetField: SheetField | null
  assignSheetField: SheetField | null
  fieldItemCache: FieldItem | null
  undoFieldItems: any[]
  undoIdx: number
  undoLimit: number
  borderWidth: number
  errors: string[]
  DirectionEnum: Readonly<{Horizontal: number;Vertical: number;}>
  SheetFieldKindEnum: Readonly<{FIELD: number; TOTAL_SCORE: number; PART1: number; VIEW_POINT: number; STUDENT_INFO: number}>
  ModeEnum: Readonly<{Waku: number;Delete: number;Assign: number; Mark: number}>
  FieldTypeEnum: Readonly<{Field: number;Mark: number;}>
  isShiftPressed: boolean
  isCtrlPressed: boolean
  isMultiSelect: boolean
  isMouseOnImageArea: boolean
  multiSelectedFieldItems: FieldItem[]
  sheetFieldNamePos: Pos
  key: number
  mode: number
  helpFields: any[]
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "alert-area": AlertArea,
    "vue-drag-resize": VueDragResize,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 4,
      currentPage: 1,
      sheet_group_key: "",
      sheet: {corretct_image_completed: true},
      sheetFields: [],
      pageItems: [],
      scale: 0.5,
      isMouseDown: false,
      beginPos: new Pos(0, 0),
      baseFieldItem: new FieldItem(),
      currentFieldItem: null,
      currentSheetField: null,
      assignSheetField: null,
      fieldItemCache: null,
      undoFieldItems: [],
      undoIdx: -1,
      undoLimit: 20,
      borderWidth: 2,
      errors: [],
      DirectionEnum: DirectionEnum,
      SheetFieldKindEnum: Common.SheetFieldKindEnum,
      FieldTypeEnum: FieldTypeEnum,
      ModeEnum: ModeEnum,
      isShiftPressed: false,
      isCtrlPressed: false,
      isMultiSelect: false,
      isMouseOnImageArea: false,
      multiSelectedFieldItems: new Array<FieldItem>(),
      sheetFieldNamePos: new Pos(0, 0),
      key: 1,
      mode: ModeEnum.Waku,
      helpFields: [
        { key: "マウスドラッグ", img: require("@/assets/images/icon_cursor.png"), description: "枠を作成" },
        { key: "Back Spaceキー", img: require("@/assets/images/keyboard_Backspace.png"), description: "選択中の枠を削除" },
        { key: "Cキー", img: require("@/assets/images/keyboard_C.png"), description: "選択中の枠をコピー" },
        { key: "Shiftキー + マウスドラッグ", img: require("@/assets/images/keyboard_Shift.png"), description: "複数の枠を選択" },
      ],
    });

    /****************************************
     * 現在表示中のページ情報
     ****************************************/

    const currentPageItem = computed(() => {
      return state.pageItems.length > 0 ? state.pageItems[state.currentPage - 1] : null;
    });

    /****************************************
     * 得点枠
     ****************************************/

    const scoreFieldItems = computed((): FieldItem[] => {
      // @ts-ignore
      return [].concat.apply([], state.pageItems.map(x => x.fieldItems.filter(y => y.fieldType == state.FieldTypeEnum.Field)));
    });

    /****************************************
     * 採点マーク枠
     ****************************************/

    const markFieldItems = computed((): FieldItem[] => {
      // @ts-ignore
      return [].concat.apply([], state.pageItems.map(x => x.fieldItems.filter(y => y.fieldType == state.FieldTypeEnum.Mark)));
    });

    /****************************************
     * 倍率を加味した画像の横幅
     ****************************************/

    const parentW = computed(() => {
      return currentPageItem.value ? currentPageItem.value.baseWidth * state.scale : 0;
    });

    /****************************************
     * 倍率を加味した画像の横幅
     ****************************************/

    const parentH = computed(() => {
      return currentPageItem.value ? currentPageItem.value.baseHeight * state.scale : 0;
    });

    /****************************************
     * 画像のサイズCSSスタイル
     ****************************************/

    const sizeStyle = computed(() => {
      let style: any = {};
      style["width"] = `${parentW.value}px`;
      style["height"] = `${parentH.value}px`;
      return style;
    });

    const markImageStyle = (fieldItem: FieldItem) => {
      let style: any = {};
      style["width"] = `${fieldItem.width * state.scale}px`;
      style["height"] = `${fieldItem.height * state.scale}px`;
      return style;
    }

    const rectDivClass = (fieldItem: FieldItem) => {
      let style: any = {};
      style["rect-div"] = true;
      style["score-rect-div"] = fieldItem.fieldType == FieldTypeEnum.Field;
      style["mark-rect-div"] = fieldItem.fieldType == FieldTypeEnum.Mark;
      style["selected"] = isSelected(fieldItem);
      return style;
    }

    /****************************************
     * 点線枠のCSSスタイル
     ****************************************/

    const baseFieldStyle = computed(() => {
      let style: any = {};
      style["left"] = `${state.baseFieldItem.x * state.scale}px`;
      style["top"] = `${state.baseFieldItem.y * state.scale}px`;
      style["width"] = `${state.baseFieldItem.width * state.scale}px`;
      style["height"] = `${state.baseFieldItem.height * state.scale}px`;
      style["display"] = state.baseFieldItem.width > 0 && state.baseFieldItem.height > 0 ? "block" : "none";
      style["border-color"] = state.isMultiSelect ? "blue" : "red";
      return style;
    });

    /****************************************
     * 手動設問割当て時にカーソルに追従する設問名のCSSスタイル
     ****************************************/

    const sheetFieldNamePosStyle = computed(() => {
      let style: any = {};
      style["left"] = `${state.sheetFieldNamePos.x + 20}px`;
      style["top"] = `${state.sheetFieldNamePos.y}px`;
      return style;
    });

    const sheetFieldMarkStyle = (sheetFieldMark: SheetFieldMark) => {
      let style: any = {};
      style["width"] = `${sheetFieldMark.width * state.scale}px`;
      style["height"] = `${sheetFieldMark.height * state.scale}px`;
      return style;
    }

    const isSelected = (fieldItem: FieldItem) => {
      if(!fieldItem.isSelectable){
        return false;
      }else if(state.multiSelectedFieldItems.length > 0){
        return state.multiSelectedFieldItems.indexOf(fieldItem) != -1;
      }else if(state.mode != state.ModeEnum.Assign){
        return state.currentFieldItem == fieldItem;
      }else{
        return fieldItem.sheetField && fieldItem.sheetField.id == state.assignSheetField.id;
      }
    };

    /****************************************
     * 画面サイズに合わせてレイアウト整形
     ****************************************/

    const adjustHeight = () => {
      context.root.$nextTick(() => {
        const winH = window.innerHeight;
        const tableArea = document.getElementById("table-area");
        const imageArea = document.getElementById("image-area");

        if(tableArea != null && imageArea != null){
          tableArea.style.height = (winH - tableArea.offsetTop) + "px";
          imageArea.style.height = (winH - imageArea.offsetTop) + "px";
        }
      });
    };

    /****************************************
     * 画像を表示エリアの横幅に合わせる
     ****************************************/

    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth - 30;
        state.scale = imageAreaW / currentPageItem.value.baseWidth;
        adjustHeight();
      }
    };

    /****************************************
     * 拡大ボタン押下
     ****************************************/

    const scaleUp = () => {
      state.scale += 0.05;
      adjustHeight();
    };

    /****************************************
     * 縮小ボタン押下
     ****************************************/

    const scaleDown = () => {
      if(state.scale > 0.2){
        state.scale -= 0.05;
        adjustHeight();
      }
    };

    /****************************************
     * 画像エリアpointerdown
     ****************************************/

    const imageAreaPointerDown = (e: PointerEvent) => {
      
      const element = (e.target as HTMLElement);
      if(element.id == "image-wrap" && (state.isShiftPressed || state.mode == state.ModeEnum.Waku)){
        element.setPointerCapture(e.pointerId);
        state.isMouseDown = true;
        state.beginPos = new Pos(e.offsetX / state.scale, e.offsetY / state.scale);
        clearCurrentItem();
        state.isMultiSelect = state.isShiftPressed;
      }else if(element.id == "image-wrap" && (state.mode == state.ModeEnum.Assign || state.mode == state.ModeEnum.Mark)){
        clearCurrentItem();
      }
    }

    /****************************************
     * 画像エリアpointermove
     ****************************************/

    const imageAreaPointerMove = (e: PointerEvent) => {
      
      const element = (e.target as HTMLElement);
      if(state.isMouseDown){
        let x = 0, y = 0;
        if(element.id == "image-wrap"){
          x = e.offsetX / state.scale;
          y = e.offsetY / state.scale;
        }
        
        if(x > state.beginPos.x){
          state.baseFieldItem.x = state.beginPos.x;
          state.baseFieldItem.width = x - state.beginPos.x;
        }else{
          state.baseFieldItem.x = x;
          state.baseFieldItem.width = state.beginPos.x - x;
        }

        if(y > state.beginPos.y){
          state.baseFieldItem.y = state.beginPos.y;
          state.baseFieldItem.height = y - state.beginPos.y;
        }else{
          state.baseFieldItem.y = y;
          state.baseFieldItem.height = state.beginPos.y - y;
        }
      }else if(state.mode == state.ModeEnum.Assign){
        let x = 0, y = 0;
        if(element.id == "image-wrap"){
          x = e.offsetX;
          y = e.offsetY;
        }else if(element.className && element.className.includes("rect-div")){
          x = e.offsetX + element.offsetLeft + 2;
          y = e.offsetY + element.offsetTop + 2;
        }else if(element.className && element.className.includes("mark-image") || element.className.includes("rect-name")){
          const parent = element.parentNode as HTMLElement;
          x = e.offsetX + parent.offsetLeft + 2;
          y = e.offsetY + parent.offsetTop + 2;
        }
        state.sheetFieldNamePos = new Pos(x, y);
        state.isMouseOnImageArea = true;
      }
    }

    /****************************************
     * 画像エリアpointerup
     ****************************************/

    const imageAreaPointerUp = (e: PointerEvent) => {
      if(state.isMouseDown){
        (e.target as HTMLElement).releasePointerCapture(e.pointerId);
        state.isMouseDown = false;
        if(state.isMultiSelect){
          setMultiSelectFields();
        }else{
          addFieldItem();
        }
      }
    }

    /****************************************
     * 画像エリアpointerleave
     ****************************************/

    const imageAreaPointerLeave = (e: PointerEvent) => {
      if(state.isMouseDown){
        (e.target as HTMLElement).releasePointerCapture(e.pointerId);
        state.isMouseDown = false;
        if(state.isMultiSelect){
          setMultiSelectFields();
        }else{
          addFieldItem();
        }
      }
      state.isMouseOnImageArea = false;
    }

    /****************************************
     * 枠複数選択 点線枠内の設問枠を選択
     ****************************************/

    const setMultiSelectFields = () => {

      clearCurrentItem();

      currentPageItem.value.fieldItems.forEach((x: FieldItem) => {

        if(x.isSelectable){
          let isSelected = true;
          if(x.x < state.baseFieldItem.x){
            isSelected = false;
          }
          if(x.y < state.baseFieldItem.y){
            isSelected = false;
          }
          if(x.x + x.width > state.baseFieldItem.x + state.baseFieldItem.width){
            isSelected = false;
          }
          if(x.y + x.height > state.baseFieldItem.y + state.baseFieldItem.height){
            isSelected = false;
          }
          if(isSelected){
            //x.isActive = false;
            state.multiSelectedFieldItems.push(x);
          }
        }
      });

      // 点線枠リセット
      state.baseFieldItem.x = 0;
      state.baseFieldItem.y = 0;
      state.baseFieldItem.width = 0;
      state.baseFieldItem.height = 0;
    }

    /****************************************
     * 枠情報追加
     ****************************************/
    
    const addFieldItem = () => {
      if(state.baseFieldItem.width > 50 && state.baseFieldItem.height > 50){
        // 点線枠から位置・サイズ情報を抽出しページ配下の枠追加
        const fieldItem = new FieldItem();
        fieldItem.key = state.key++;
        fieldItem.x = state.baseFieldItem.x;
        fieldItem.y = state.baseFieldItem.y;
        fieldItem.width = state.baseFieldItem.width;
        fieldItem.height = state.baseFieldItem.height;
        fieldItem.fieldType = state.FieldTypeEnum.Field;
        fieldItem.isDraggable = true;
        fieldItem.isResizable = true;
        fieldItem.isSelectable = true;
        currentPageItem.value.fieldItems.push(fieldItem);
        changeCurrentFieldItem(fieldItem);
      }
      
      // 点線枠リセット
      state.baseFieldItem.x = 0;
      state.baseFieldItem.y = 0;
      state.baseFieldItem.width = 0;
      state.baseFieldItem.height = 0;
    };

    const editTargetFieldItems = computed(() => {
      return state.multiSelectedFieldItems.length > 0 ? state.multiSelectedFieldItems : [state.currentFieldItem];
    });

    /****************************************
     * 枠のドラッグ中イベント
     ****************************************/

    const dragging = (rect: any) => {

      // 単一選択の場合は処理終了
      if(state.multiSelectedFieldItems.length == 0){
        return;
      }

      const addX = (rect.left / state.scale) - state.fieldItemCache.x;
      const addY = (rect.top / state.scale) - state.fieldItemCache.y;

      // 複数選択中の枠をドラッグに追随させる
      editTargetFieldItems.value.forEach(x => {
        x.x += addX;
        x.y += addY;
      });

      state.fieldItemCache.x = rect.left / state.scale;
      state.fieldItemCache.y = rect.top / state.scale;
    }

    /****************************************
     * 枠のドラッグ終了時イベント
     ****************************************/
    
    const dragStop = (rect: any) => {

      if(state.multiSelectedFieldItems.length == 0){

        const fieldItem = editTargetFieldItems.value[0];

        if(rect.left < 0){
          fieldItem.x = 0;
        }else if(rect.left + rect.width > parentW.value){
          fieldItem.x = (parentW.value - rect.width) / state.scale;
        }else{
          fieldItem.x = rect.left / state.scale;
        }

        if(rect.top < 0){
          fieldItem.y = 0;
        }else if(rect.top + rect.height > parentH.value){
          fieldItem.y = (parentH.value - rect.height) / state.scale;
        }else{
          fieldItem.y = rect.top / state.scale;
        }
      }else{
        // 複数選択時のドラッグ終了処理
        const addX = (rect.left / state.scale) - state.fieldItemCache.x;
        const addY = (rect.top / state.scale) - state.fieldItemCache.y;

        editTargetFieldItems.value.forEach(x => {

          x.x += addX;
          x.y += addY;

          if(x.x < 0){
            x.x = x.x == 1 ? 0 : 1;
          }else if((x.x + x.width) * state.scale > parentW.value){
            x.x = x.x == (parentW.value - (x.width * state.scale)) / state.scale ? (parentW.value - (x.width * state.scale)) / state.scale - 1 : (parentW.value - (x.width * state.scale)) / state.scale;
          }

          if(x.y < 0){
            x.y = x.y == 1 ? 0 : 1;
          }else if((x.y + x.height) * state.scale > parentH.value){
            x.y = (x.y + x.height) * state.scale == parentH.value ? parentH.value - (x.height * state.scale) - 1 : parentH.value - (x.height * state.scale);
            ;
          }
        });
      }

      // setUndoFieldItems();
    };

    /****************************************
     * 枠のリサイズ中イベント
     ****************************************/

    const resizing = (rect: any) => {

      // 単一選択の場合は処理終了
      if(state.multiSelectedFieldItems.length == 0){
        return;
      }

      const addX = (rect.left / state.scale) - state.fieldItemCache.x;
      const addY = (rect.top / state.scale) - state.fieldItemCache.y;

      // 複数選択中の枠をドラッグに追随させる
      editTargetFieldItems.value.forEach(x => {
        x.width = rect.width / state.scale;
        x.height = rect.height / state.scale;
        x.x += addX;
        x.y += addY;
      });

      state.fieldItemCache.x = rect.left / state.scale;
      state.fieldItemCache.y = rect.top / state.scale;
      state.fieldItemCache.width = rect.width / state.scale;
      state.fieldItemCache.height = rect.height / state.scale;
    }

    /****************************************
     * 枠のリサイズ終了時イベント
     ****************************************/
    
    const resizeStop = (rect: any) => {

      if(state.multiSelectedFieldItems.length == 0){

        const fieldItem = editTargetFieldItems.value[0];

        if(rect.left < 0){
          fieldItem.width = fieldItem.width + fieldItem.x;
          fieldItem.x = 0;
        }else if(rect.left + rect.width > parentW.value){
          fieldItem.width = (parentW.value - rect.left) / state.scale;
        }else{
          fieldItem.width = rect.width / state.scale;
          fieldItem.x = rect.left / state.scale;
        }

        if(rect.top < 0){
          fieldItem.height = fieldItem.height + fieldItem.y;
          fieldItem.y = 0;
        }else if(rect.top + rect.height > parentH.value){
          fieldItem.height = (parentH.value - rect.top) / state.scale;
        }else{
          fieldItem.height = rect.height / state.scale;
          fieldItem.y = rect.top / state.scale;
        }
      }else{
        const addX = (rect.left / state.scale) - state.fieldItemCache.x;
        const addY = (rect.top / state.scale) - state.fieldItemCache.y;

        editTargetFieldItems.value.forEach(x => {

          x.width = rect.width / state.scale;
          x.height = rect.height / state.scale;
          x.x += addX;
          x.y += addY;

          if(x.x < 0){
            x.x = x.x == 1 ? 0 : 1;
          }else if((x.x + x.width) * state.scale > parentW.value){
            x.x = x.x == (parentW.value - (x.width * state.scale)) / state.scale ? (parentW.value - (x.width * state.scale)) / state.scale - 1 : (parentW.value - (x.width * state.scale)) / state.scale;
          }

          if(x.y < 0){
            x.y = x.y == 1 ? 0 : 1;
          }else if((x.y + x.height) * state.scale > parentH.value){
            x.y = (x.y + x.height) * state.scale == parentH.value ? parentH.value - (x.height * state.scale) - 1 : parentH.value - (x.height * state.scale);
            ;
          }
        });
      }

      // setUndoFieldItems();
    };

    /****************************************
     * 枠をクリック
     ****************************************/

    const fieldClick = (fieldItem: FieldItem) => {

      if(state.mode == state.ModeEnum.Delete){
        deleteFieldItem(fieldItem);
      }else if(state.mode == state.ModeEnum.Assign){

        // 採点マークの場合は何もしない
        if(fieldItem.fieldType == state.FieldTypeEnum.Mark){
          return;
        }

        // 枠に設問を割り当てる
        scoreFieldItems.value.filter(x => x.sheetField && x.sheetField.id == state.assignSheetField.id).forEach(x => x.sheetField = null);
        fieldItem.sheetField = state.assignSheetField;

        changeCurrentFieldItem(fieldItem);
        const nextIdx = state.sheetFields.indexOf(state.assignSheetField) + 1;
        
        if(nextIdx + 1 > state.sheetFields.length){
          // 最後の設問だった場合、手動モードをOFF
          state.assignSheetField = null;
          state.mode = state.ModeEnum.Waku;
        }else{
          // 次の設問へ切り替え
          state.assignSheetField = state.sheetFields[nextIdx];
        }
      }else{
        if(state.currentFieldItem || (!state.currentFieldItem && state.multiSelectedFieldItems.length == 0)){
          clearCurrentItem();
          changeCurrentFieldItem(fieldItem);
        }else if(state.multiSelectedFieldItems.filter(x => x.key == fieldItem.key).length == 0){
          // 複数選択中の枠以外をクリックした場合、選択中の複数枠の選択をクリアしてクリックした枠に選択変更
          // 選択変更するだけだと選択中の複数枠にリサイズ用要素が残ってしまうため一旦配列をクリアしてから再格納し直している
          const fieldItems = currentPageItem.value.fieldItems.filter(x => x != fieldItem).map(x => x);
          currentPageItem.value.fieldItems = [fieldItem];
          context.root.$nextTick(() => {
            fieldItems.forEach(x => currentPageItem.value.fieldItems.push(x));
            clearCurrentItem();
            changeCurrentFieldItem(fieldItem);
          });
        }else{
          // 複数選択中の枠から一つクリックした場合
          const fieldItems = currentPageItem.value.fieldItems.filter(x => x != fieldItem).map(x => x);
          currentPageItem.value.fieldItems = [fieldItem];
          context.root.$nextTick(() => {
            fieldItems.forEach(x => currentPageItem.value.fieldItems.push(x));
          });
        }

        state.fieldItemCache = fieldItem;
      }
    };

    /****************************************
     * アンドゥ情報追加
     ****************************************/

    const setUndoFieldItems = () => {

      const undoFieldItems = [];
      for(let i = 0; i < state.undoIdx + 1; i++){
        undoFieldItems.push(state.undoFieldItems[i]);
      }
      state.undoFieldItems = undoFieldItems;

      if(state.undoIdx >= state.undoLimit - 1){
        const undoFieldItems = [];
        for(let i = 0; i < state.undoLimit; i++){
          if(i == 0){
            continue;
          }
          undoFieldItems.push(state.undoFieldItems[i]);
        }
        state.undoFieldItems = undoFieldItems;
        state.undoIdx--;
      }

      const fieldItems = new Array<FieldItem>();
      currentPageItem.value.fieldItems.forEach(x => {
        const fieldItem = new FieldItem();
        fieldItem.key = x.key;
        fieldItem.x = x.x;
        fieldItem.y = x.y;
        fieldItem.width = x.width;
        fieldItem.height = x.height;
        fieldItem.pageNo = x.pageNo;
        fieldItem.sheetFieldMark = x.sheetFieldMark;
        fieldItem.sheetField = x.sheetField;
        fieldItem.fieldType = x.fieldType;
        fieldItem.isDraggable = x.isDraggable;
        fieldItem.isResizable = x.isResizable;
        fieldItem.isSelectable = x.isSelectable;
        fieldItems.push(fieldItem);
      });
      
      state.undoFieldItems.push(fieldItems);
      state.undoIdx++;
    }

    /****************************************
     * アンドゥ情報クリア
     ****************************************/

    const clearUndoFieldItems = () => {
      state.undoIdx = -1;
      setUndoFieldItems();
    }

    /****************************************
     * 一覧の行クリック
     ****************************************/
    
    const trClick = (sheetField: SheetField) => {
      if(state.mode == state.ModeEnum.Assign){
        state.assignSheetField = sheetField;
        state.currentPage = sheetField.page;
      }else{
        changeCurrentSheetField(sheetField);
      }
      scrollImageArea(sheetField);
    };

    /****************************************
     * 一覧スクロール
     ****************************************/

    const scrollTableArea = (sheetField: SheetField) => {
      if(!sheetField){
        return;
      }
      const scrollArea = document.getElementById("table-area");
      const trArea = document.getElementById(`tr-${sheetField.id}`);

      const scrollAreaHeight = scrollArea.offsetHeight;
      const scrollAreaTop = scrollArea.scrollTop;
      const scrollAreaBottom = scrollAreaTop + scrollAreaHeight;
      const trTop = trArea.offsetTop;
      const trBottom = trArea.offsetTop + trArea.offsetHeight;

      if(scrollAreaTop > trTop){
        scrollArea.scrollTop -= trArea.offsetHeight;
      }else if(scrollAreaBottom < trBottom){
        scrollArea.scrollTop += trArea.offsetHeight;
      }
    }

    /****************************************
     * 枠までスクロール
     ****************************************/

    const scrollImageArea = (sheetField: SheetField) => {
      const fieldItem = currentPageItem.value.fieldItems.filter(x => x.sheetField == sheetField)
      if(fieldItem.length == 0){
        return;
      }

      const rectElement = document.getElementById(`${fieldItem[0].key}`);
      const imageArea = document.getElementById("image-area");

      const imageAreaWidth = imageArea.offsetWidth;
      const imageAreaHeight = imageArea.offsetHeight;
      const imageAreaTop = imageArea.scrollTop;
      const imageAreaBottom = imageAreaTop + imageAreaHeight;
      const imageAreaLeft = imageArea.scrollLeft;
      const imageAreaRight = imageArea.scrollLeft + imageAreaWidth;
      const rectTop = rectElement.offsetTop;
      const rectBottom = rectElement.offsetTop + rectElement.offsetHeight;
      const rectLeft = rectElement.offsetLeft;
      const rectRight = rectElement.offsetLeft + rectElement.offsetWidth;

      let fromTop = imageAreaTop;
      let toTop = imageAreaTop;
      let fromLeft = imageAreaLeft;
      let toLeft = imageAreaLeft;

      if(imageAreaTop > rectTop || imageAreaBottom < rectBottom){
        toTop = rectTop - (imageAreaHeight / 3);
      }

      if(imageAreaLeft > rectLeft || imageAreaRight < rectRight){
        toLeft = rectLeft - (imageAreaWidth / 3);
      }

      if(fromTop != toTop || fromLeft != toLeft){
        Common.smoothScroll(fromTop, toTop, fromLeft, toLeft, imageArea);
      }
    }

    /****************************************
     * モード変更
     ****************************************/

    const changeMode = (mode: number) => {
      
      if(state.mode == mode){
        return;
      }
      
      if(mode == state.ModeEnum.Assign){
        state.assignSheetField = state.currentSheetField ? state.currentSheetField : state.sheetFields[0];
      }
      clearCurrentItem();
      state.mode = mode;
      (document.activeElement as HTMLElement).blur();

      scoreFieldItems.value.forEach(x => {
        x.isDraggable = state.mode == state.ModeEnum.Waku;
        x.isResizable = state.mode == state.ModeEnum.Waku;
        x.isSelectable = state.mode == state.ModeEnum.Waku || state.mode == state.ModeEnum.Assign;
      });

      markFieldItems.value.forEach(x => {
        x.isDraggable = state.mode == state.ModeEnum.Mark;
        x.isResizable = state.mode == state.ModeEnum.Mark;
        x.isSelectable = state.mode == state.ModeEnum.Mark;
      });

      // clearUndoFieldItems();
    }
    
    /****************************************
     * 枠情報削除
     ****************************************/
    
    const deleteFieldItem = (fieldItem: FieldItem) => {
      const fieldItems = currentPageItem.value.fieldItems.filter((x: FieldItem) => x != fieldItem && !state.multiSelectedFieldItems.includes(x));
      currentPageItem.value.fieldItems = fieldItems;
      state.currentFieldItem = null;
      state.currentSheetField = null;
    };

    /****************************************
     * 選択中の枠変更
     ****************************************/
    
    const changeCurrentFieldItem = (fieldItem: FieldItem) => {
      clearCurrentItem();
      fieldItem.isActive = true;
      state.currentFieldItem = fieldItem;
      if(fieldItem.sheetField != null){
        state.currentSheetField = fieldItem.sheetField;
      }
    };

    /****************************************
     * 選択中の設問変更
     ****************************************/

    const changeCurrentSheetField = (sheetField: SheetField) => {
      state.currentSheetField = sheetField;
      state.currentFieldItem = null;

      scoreFieldItems.value.forEach(x => {
        if(x.sheetField && x.sheetField.id == sheetField.id){
          x.isActive = true;
          state.currentFieldItem = x;
          state.currentPage = x.pageNo;
        }else{
          x.isActive = false;
        }
      });
    }

    /****************************************
     * 枠設定完了判定
     ****************************************/

    const isFieldSettingCompleted = (sheetField: SheetField) => {
      return scoreFieldItems.value.filter(x => x.sheetField && x.sheetField.id == sheetField.id).length > 0;
    }

    /****************************************
     * 枠選択情報クリア
     ****************************************/
    
    const clearCurrentItem = () => {
      state.currentFieldItem = null;
      state.currentSheetField = null;
      state.multiSelectedFieldItems = [];
      state.pageItems[state.currentPage - 1].fieldItems.forEach((x: FieldItem) => x.isActive = false);
    };
    
    /****************************************
     * 枠自動設定 API呼び出し
     ****************************************/
    
    const autoCreateFieldItems = async () => {

      context.root.$store.dispatch("showOverlay");

      await http.get(`/api/teacher/position_edit/image_rect_auto_generate/${state.sheet_group_key}?page=${state.currentPage}&direction=horizontal`).then(response => {
        let fieldItems = new Array<FieldItem>();
        for(const rimArray of response.data.result){
          let item = new FieldItem();
          item.key = state.key++;
          item.x = rimArray[0];
          item.y = rimArray[1];
          item.width = rimArray[2];
          item.height = rimArray[3];
          item.fieldType = state.FieldTypeEnum.Field;
          fieldItems.push(item);
        }
        currentPageItem.value.fieldItems.filter(x => x.fieldType == state.FieldTypeEnum.Mark).forEach(x => {
          fieldItems.push(x);
        });

        currentPageItem.value.fieldItems = fieldItems;
        state.currentFieldItem = null;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /****************************************
     * 枠情報リセット
     ****************************************/
    
    const resetFieldItems = () => {
      if(!window.confirm("設定した枠を全て削除します。よろしいですか？")){
        return;
      }
      state.pageItems.forEach(x => x.fieldItems = x.fieldItems.filter(y => y.fieldType == state.FieldTypeEnum.Mark));
      state.currentFieldItem = null;
    };

    /****************************************
     * 設問割当て自動設定
     ****************************************/
    
    const autoAssignSheetFields = (direction: number) => {

      // 割当対象取得 範囲指定の場合は範囲内の枠、指定なしの場合はページ内の全ての枠が対象
      let assignTargets = state.multiSelectedFieldItems.length > 0 ? state.multiSelectedFieldItems : currentPageItem.value.fieldItems.filter(x => x.fieldType == state.FieldTypeEnum.Field);

      assignTargets.forEach(x => {
        x.sheetField = null;
      });

      if(state.assignSheetField == null){
        state.assignSheetField = state.sheetFields[0];
      }

      setSortNo(assignTargets, 1, direction);
      for(const fieldItem of assignTargets.sort((a: FieldItem, b: FieldItem) => a.sortNo - b.sortNo)){
        scoreFieldItems.value.filter(x => x.sheetField && x.sheetField.id == state.assignSheetField.id).forEach(x => x.sheetField = null);
        fieldItem.sheetField = state.assignSheetField;
        const nextIdx = state.sheetFields.indexOf(state.assignSheetField) + 1;
        if(nextIdx == state.sheetFields.length){
          state.assignSheetField = null;
          state.mode = state.ModeEnum.Waku;
          break;
        }else{
          state.assignSheetField = state.sheetFields[nextIdx];
          scrollTableArea(state.assignSheetField);
        }
      }
    };

    /****************************************
     * 設問自動割当て用の順序番号設定
     ****************************************/
    
    const setSortNo = (fieldItems: FieldItem[], num: number, direction: number) => {
      if(direction == state.DirectionEnum.Horizontal){
        const topField = fieldItems.sort((a, b) => a.y - b.y)[0];

        let someFields = fieldItems.filter(f => f.y - topField.y < 50);
        let otherFields = fieldItems.filter(f => !(f.y - topField.y < 50));

        someFields.sort((a, b) => a.x - b.x).forEach(f => {
          f.sortNo = num;
          num += 1;
        });

        if (otherFields.length > 0) {
          setSortNo(otherFields, num, direction);
        }
      }else{
        const rightField = fieldItems.sort((a, b) => (b.x + b.width) - (a.x + a.width))[0];

        let someFields = fieldItems.filter(f => (rightField.x + rightField.width) - (f.x + f.width) < 50);
        let otherFields = fieldItems.filter(f => !((rightField.x + rightField.width) - (f.x + f.width) < 50));

        someFields.sort((a, b) => a.y - b.y).forEach(f => {
          f.sortNo = num;
          num += 1;
        });

        if (otherFields.length > 0) {
          setSortNo(otherFields, num, direction);
        }
      }
    };

    /****************************************
     * 設問割当てリセット
     ****************************************/
    
    const resetSheetFields = () => {
      if(!window.confirm("割当を全てリセットします。よろしいですか？")){
        return;
      }
      state.currentSheetField = null;
      scoreFieldItems.value.forEach(x => x.sheetField = null);
      state.assignSheetField = state.sheetFields[0];
      scrollTableArea(state.assignSheetField);
    };

    /****************************************
     * keydown
     ****************************************/

    const keyDown = (e:KeyboardEvent) => {
      
      if(e.key == "ArrowUp"){
        e.preventDefault();

        let sheetField: SheetField = null;

        if(state.mode == state.ModeEnum.Waku){
          if(state.currentSheetField == null){
            const idx = state.sheetFields.length - 1;
            sheetField = state.sheetFields[idx];
          }else{
            const idx = state.sheetFields.indexOf(state.currentSheetField);
            if(idx > 0){
              sheetField = state.sheetFields[idx - 1]
            }
          }

          if(sheetField){
            changeCurrentSheetField(sheetField);
            context.root.$nextTick(() => {
              scrollImageArea(sheetField);
              scrollTableArea(sheetField)
            });
          }
        }else{
          if(state.assignSheetField == null){
            const idx = state.sheetFields.length - 1;
            sheetField = state.sheetFields[idx];
          }else{
            const idx = state.sheetFields.indexOf(state.assignSheetField);
            if(idx > 0){
              sheetField = state.sheetFields[idx - 1];
            }
          }
          
          if(sheetField){
            state.assignSheetField = sheetField;
            state.currentPage = state.assignSheetField.page;
            context.root.$nextTick(() => {
              scrollImageArea(sheetField);
              scrollTableArea(sheetField);
            });
          }
        }
      }else if(e.key == "ArrowDown"){
        e.preventDefault();

        let sheetField: SheetField = null;

        if(state.mode == state.ModeEnum.Waku){
          if(state.currentSheetField == null){
            sheetField = state.sheetFields[0];
          }else{
            const idx = state.sheetFields.indexOf(state.currentSheetField);
            if(idx + 1 < state.sheetFields.length){
              state.multiSelectedFieldItems = new Array<FieldItem>();
              sheetField = state.sheetFields[idx + 1];
            }
          }

          if(sheetField){
            changeCurrentSheetField(sheetField);
            context.root.$nextTick(() => {
              scrollImageArea(sheetField);
              scrollTableArea(sheetField)
            });
          }
        }else{
          if(state.assignSheetField == null){
            sheetField = state.sheetFields[0] 
          }else{
            const idx = state.sheetFields.indexOf(state.assignSheetField);
            if(idx + 1 < state.sheetFields.length){
              state.multiSelectedFieldItems = new Array<FieldItem>();
              sheetField = state.sheetFields[idx + 1]
            }
          }
          
          if(sheetField){
            state.assignSheetField = sheetField;
            state.currentPage = state.assignSheetField.page;
            context.root.$nextTick(() => {
              scrollImageArea(sheetField);
              scrollTableArea(sheetField);
            });
          }
        }
      }else if(e.key == "a" && state.isCtrlPressed){
        if(state.mode == state.ModeEnum.Waku){
          e.preventDefault();
          state.multiSelectedFieldItems = currentPageItem.value.fieldItems.filter(x => x.fieldType == state.FieldTypeEnum.Field);
        }else if(state.mode == state.ModeEnum.Mark){
          e.preventDefault();
          state.multiSelectedFieldItems = currentPageItem.value.fieldItems.filter(x => x.fieldType == state.FieldTypeEnum.Mark);
        }
      }else if(e.key == "c"){
        if(state.mode != state.ModeEnum.Waku){
          return;
        }

        e.preventDefault();
        
        if(state.multiSelectedFieldItems.length > 0){
          // 複数選択中の枠をコピー
          const newMultiSelectedFieldItems = new Array<FieldItem>();
          for(const fieldItem of state.multiSelectedFieldItems){
            const newFieldItem = copyFieldItem(fieldItem);
            newMultiSelectedFieldItems.push(newFieldItem);
          }

          const keys = newMultiSelectedFieldItems.map(x => x.key);
          
          const fieldItems = currentPageItem.value.fieldItems.filter(x => !keys.includes(x.key)).map(x => x);
          currentPageItem.value.fieldItems = newMultiSelectedFieldItems.map(x => x);
          state.multiSelectedFieldItems = newMultiSelectedFieldItems.map(x => x);
          context.root.$nextTick(() => {
            fieldItems.forEach(x => currentPageItem.value.fieldItems.push(x));
            clearCurrentItem();  
            state.multiSelectedFieldItems = newMultiSelectedFieldItems;
          });
        }else if(state.currentFieldItem != null){
          // 選択中の枠単体をコピー
          const newFieldItem = copyFieldItem(state.currentFieldItem);
          newFieldItem.isActive = true;

          const fieldItems = currentPageItem.value.fieldItems.filter(x => x != newFieldItem).map(x => x);
          currentPageItem.value.fieldItems = [newFieldItem];
          context.root.$nextTick(() => {
            fieldItems.forEach(x => currentPageItem.value.fieldItems.push(x));
            clearCurrentItem();
            changeCurrentFieldItem(newFieldItem);
          });
        }
      // }else if(e.key == "z" && state.isCtrlPressed && state.undoIdx > 0){
      //   state.undoIdx--;
      //   state.pageItems[state.currentPage - 1].fieldItems = state.undoFieldItems[state.undoIdx].map((x: FieldItem) => {
      //     const fieldItem = new FieldItem();
      //     fieldItem.key = x.key;
      //     fieldItem.x = x.x;
      //     fieldItem.y = x.y;
      //     fieldItem.width = x.width;
      //     fieldItem.height = x.height;
      //     fieldItem.pageNo = x.pageNo;
      //     fieldItem.sheetFieldMark = x.sheetFieldMark;
      //     fieldItem.sheetField = x.sheetField;
      //     fieldItem.fieldType = x.fieldType;
      //     fieldItem.isDraggable = x.isDraggable;
      //     fieldItem.isResizable = x.isResizable;
      //     fieldItem.isSelectable = x.isSelectable;
      //     return fieldItem;
      //   });
      // }else if(e.key == "y" && state.isCtrlPressed && state.undoIdx + 1 < state.undoFieldItems.length){
      //   state.undoIdx++;
      //   state.pageItems[state.currentPage - 1].fieldItems = state.undoFieldItems[state.undoIdx].map((x: FieldItem) => {
      //     const fieldItem = new FieldItem();
      //     fieldItem.key = x.key;
      //     fieldItem.x = x.x;
      //     fieldItem.y = x.y;
      //     fieldItem.width = x.width;
      //     fieldItem.height = x.height;
      //     fieldItem.pageNo = x.pageNo;
      //     fieldItem.sheetFieldMark = x.sheetFieldMark;
      //     fieldItem.sheetField = x.sheetField;
      //     fieldItem.fieldType = x.fieldType;
      //     fieldItem.isDraggable = x.isDraggable;
      //     fieldItem.isResizable = x.isResizable;
      //     fieldItem.isSelectable = x.isSelectable;
      //     return fieldItem;
      //   });
      }else if(e.key == "Backspace"){
        if(state.mode == state.ModeEnum.Waku){
          e.preventDefault();
          deleteFieldItem(state.currentFieldItem);
        }
      }else if(e.key == "Shift"){
        e.preventDefault();
        state.isShiftPressed = true;
      }else if(e.key == "Control"){
        e.preventDefault();
        state.isCtrlPressed = true;
			}
    }

    /****************************************
     * keyup
     ****************************************/

    const keyUp = (e:KeyboardEvent) => {
      if(e.key == "Shift"){
        e.preventDefault();
        state.isShiftPressed = false;
      }else if(e.key == "Control"){
        e.preventDefault();
        state.isCtrlPressed = false;
      }
    }

    /****************************************
     * 保存ボタン押下
     ****************************************/
    
    const saveSheetFields = async () => {

      // エラーチェック
      state.errors = [];

      state.sheetFields.forEach(sheetField => {
        if(scoreFieldItems.value.filter((x: FieldItem) => x.sheetField && x.sheetField.id == sheetField.id).length == 0){
          state.errors.push(`${sheetField.name}の枠が設定されていません。`);
        }else if(scoreFieldItems.value.filter((x: FieldItem) => x.sheetField && x.sheetField.id == sheetField.id).length > 1){
          state.errors.push(`${sheetField.name}の枠が複数設定されています。`);
        }
      });

      // エラーありの場合は処理終了
      if(state.errors.length > 0 || !window.confirm("採点枠を保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      let sheetFields = new Array<SheetField>();
      state.pageItems.forEach(pageItem => {
        pageItem.fieldItems.filter(x => x.sheetField != null).forEach(fieldItem => {
          const rim = [fieldItem.x, fieldItem.y, fieldItem.width, fieldItem.height];
          fieldItem.sheetField.rim = rim;
          fieldItem.sheetField.page = pageItem.pageNo;
          sheetFields.push(fieldItem.sheetField);
        });
      });

      let sheetFieldMarks = new Array<SheetFieldMark>();
      state.pageItems.forEach(pageItem => {
        pageItem.fieldItems.filter(x => x.sheetFieldMark != null).forEach(fieldItem => {
          fieldItem.sheetFieldMark.x = fieldItem.x;
          fieldItem.sheetFieldMark.y = fieldItem.y;
          fieldItem.sheetFieldMark.width = fieldItem.width;
          fieldItem.sheetFieldMark.height = fieldItem.height;
          sheetFieldMarks.push(fieldItem.sheetFieldMark);
        });
      });

      // id順にソート
      sheetFields = sheetFields.sort((a, b) => a.id - b.id);

      await http.post(`/api/teacher/score_position_edit/update/${state.sheet_group_key}`, {sheet_fields: sheetFields, sheet_field_marks: sheetFieldMarks}).then(response => {
        alert("処理が完了しました。");

        if(context.root.$store.state.sheetType == Common.SheetTypeEnum.Entrance){
          context.root.$router.push('/teacher_site/entrance_sheet_list').catch(err => {});
        }else if(context.root.$store.state.sheetType == Common.SheetTypeEnum.Cbt){
          context.root.$router.push(`/teacher_site/mondai_pdf_upload/${state.sheet_group_key}`).catch(err => {});
        }else if(context.root.$store.state.sheetType == Common.SheetTypeEnum.Practice){
          context.root.$router.push('/teacher_site/practice_sheet_list').catch(err => {});
        }else{
          if(context.root.$store.state.isDigitalPaper){
            context.root.$router.push(`/teacher_site/answer_image_upload/${state.sheet_group_key}`).catch(err => {});
          }else{
            context.root.$router.push('/teacher_site/sheet_list').catch(err => {});
          }
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /****************************************
     * ページ切り替え
     ****************************************/
    
    const changePage = (page: number) => {
      if(state.mode != state.ModeEnum.Assign){
        clearCurrentItem();
      }
    };

    /****************************************
     * 選択中の枠を複製
     ****************************************/
    
    const copyFieldItem = (baseFieldItem: FieldItem) => {
      let fieldItem = new FieldItem();
      fieldItem.key = state.key++;
      fieldItem.width = baseFieldItem.width;
      fieldItem.height = baseFieldItem.height;
      fieldItem.x = baseFieldItem.x;
      fieldItem.y = baseFieldItem.y + baseFieldItem.height;
      fieldItem.fieldType = state.FieldTypeEnum.Field;
      fieldItem.isDraggable = true;
      fieldItem.isResizable = true;
      fieldItem.isSelectable = true;
      
      currentPageItem.value.fieldItems.push(fieldItem);
      return fieldItem;
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;

      // APIで登録済み試験情報取得
      await http.get(`/api/teacher/score_position_edit?sheet_group_key=${state.sheet_group_key}`).then(response => {
        
        state.sheet = response.data.sheet;
        state.sheetFields = response.data.sheet_fields.map((x: any) => new SheetField(x));

        if(response.data.sheet.corretct_image_completed){

          // ページごとに取得データを仕分ける
          for(let i = 0; i < state.sheet.page_count; i++){
            const pageItem = new PageItem(i + 1, response.data.base64_images[i], response.data.image_size_hashes[i].width, response.data.image_size_hashes[i].height);
            
            for(var sheet_field of state.sheetFields.filter(x => x.rim && x.page == i + 1)){
              
              // 答案並び替え機能が無効の場合は生徒情報枠は表示対象外
              if(!state.sheet.is_sort_answer_image_enable && !state.sheet.is_mask_student_info && sheet_field.kind == Common.SheetFieldKindEnum.STUDENT_INFO){
                continue;
              }

              // 観点得点出力機能が無効の場合は観点得点枠は表示対象外
              if(!state.sheet.is_print_view_point && sheet_field.kind == Common.SheetFieldKindEnum.VIEW_POINT){
                continue;
              }
              
              let fieldItem = new FieldItem();
              fieldItem.key = state.key++;
              fieldItem.x = sheet_field.rim[0];
              fieldItem.y = sheet_field.rim[1];
              fieldItem.width = sheet_field.rim[2];
              fieldItem.height = sheet_field.rim[3];
              fieldItem.pageNo = sheet_field.page;
              fieldItem.sheetField = sheet_field;
              fieldItem.isDraggable = true;
              fieldItem.isResizable = true;
              fieldItem.isSelectable = true;
              fieldItem.fieldType = state.FieldTypeEnum.Field;
              pageItem.fieldItems.push(fieldItem);
            }

            for(const sheet_field_mark of response.data.sheet_field_marks.filter((x: any) => x.page == pageItem.pageNo)){
              let fieldItem = new FieldItem();
              fieldItem.key = state.key++;
              fieldItem.x = sheet_field_mark.x;
              fieldItem.y = sheet_field_mark.y;
              fieldItem.width = sheet_field_mark.width;
              fieldItem.height = sheet_field_mark.height;
              fieldItem.pageNo = sheet_field_mark.page;
              fieldItem.sheetFieldMark = new SheetFieldMark(sheet_field_mark);
              fieldItem.fieldType = state.FieldTypeEnum.Mark;
              fieldItem.isDraggable = false;
              fieldItem.isResizable = false;
              fieldItem.isSelectable = false;
              pageItem.fieldItems.push(fieldItem);
            }

            state.pageItems.push(pageItem);
          }
          //setUndoFieldItems();
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("keydown", keyDown);
      window.addEventListener("keyup", keyUp);

      const tableArea = document.getElementById("table-area");
      const headerLeftArea = document.getElementById("header-left-area");
      headerLeftArea.style.width = `${tableArea.clientWidth}px`;

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("keyup", keyUp);
    });

    return {
      ...toRefs(state),
      currentPageItem,
      scoreFieldItems,
      parentW,
      sizeStyle,
      baseFieldStyle,
      sheetFieldNamePosStyle,
      isSelected,
      focus,
      adjustHeight,
      adjustWidth,
      scaleUp,
      scaleDown,
      addFieldItem,
      dragStop,
      resizeStop,
      fieldClick,
      trClick,
      deleteFieldItem,
      changeCurrentFieldItem,
      clearCurrentItem,
      autoCreateFieldItems,
      resetFieldItems,
      autoAssignSheetFields,
      setSortNo,
      resetSheetFields,
      saveSheetFields,
      changePage,
      copyFieldItem,
      isFieldSettingCompleted,
      changeMode,
      dragging,
      resizing,
      imageAreaPointerDown,
      imageAreaPointerMove,
      imageAreaPointerUp,
      imageAreaPointerLeave,
      sheetFieldMarkStyle,
      markFieldItems,
      markImageStyle,
      rectDivClass,
    };
  }
});
